module.exports = __webpack_public_path__ + "static/media/emptyBacklog.9b57f163.svg";